import UserTypeSelect from './UserTypeSelect'
import { prop } from 'ramda'
import { connect } from 'react-redux'
import { setUserType } from 'pages/authentication/authenticationSlice'

const mapStateToProps = ({ authentication }) => ({
  userType: prop('userType', authentication)
})

const mapDispatchToProps = {
  setUserType
}

export default connect(mapStateToProps, mapDispatchToProps)(UserTypeSelect)
